// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + {"69":"forum/components/WarningPage","455":"forum/components/WarningModal"}[chunkId] + ".js";
};